import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Dashboard.module.css';

const MunicipalityLandscapeDashboard = ({ onNavigateToMap }) => {
  const { user, userRole, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Genel Bakış', icon: '' },
    { id: 'projects', label: 'Peyzaj Projeleri', icon: '' },
    { id: 'irrigation', label: 'Sulama Yönetimi', icon: '' },
    { id: 'reports', label: 'Raporlar', icon: '' },
  ];

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardHeader}>
        <div>
          <h1>Peyzaj Yönetimi Dashboard</h1>
          <p>Hoş geldiniz, {user?.email || user?.username}</p>
          <p className={styles.roleBadge}>Rol: {userRole}</p>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <button 
            onClick={logout}
            className={styles.logoutButton}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.2)';
            }}
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      <div className={styles.dashboardTabs}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className={styles.tabIcon}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.dashboardContent}>
        {activeTab === 'overview' && (
          <div className={styles.overviewContainer}>
            <div className={styles.overviewHeader}>
              <h2>Genel Bakış</h2>
              <button 
                onClick={onNavigateToMap}
                className={styles.mapButton}
              >
                <span className={styles.mapButtonIcon}></span>
                Harita Üzerinden İnceleme Yap
              </button>
            </div>
            <div className={styles.overviewCards}>
              <div className={styles.overviewCard}>
                <h3>Aktif Projeler</h3>
                <p className={styles.cardValue}>9</p>
                <p className={styles.cardLabel}>Devam eden</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Toplam Alan</h3>
                <p className={styles.cardValue}>45 ha</p>
                <p className={styles.cardLabel}>Yönetilen alan</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Sulama Sistemi</h3>
                <p className={styles.cardValue}>Aktif</p>
                <p className={styles.cardLabel}>12/15 bölge</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'projects' && (
          <div className={styles.projectsContainer}>
            <div className={styles.projectsHeader}>
              <h2>Peyzaj Projeleri</h2>
              <button className={styles.addButton}>+ Yeni Proje</button>
            </div>
            
            <div className={styles.projectsGrid}>
              <div className={styles.projectCard}>
                <div className={styles.projectHeader}>
                  <h3>Merkez Park Yenileme</h3>
                  <span className={styles.statusBadge}>Devam Ediyor</span>
                </div>
                <p className={styles.projectDescription}>
                  Merkez parkın peyzaj düzenlemesi ve sulama sisteminin modernizasyonu
                </p>
                <div className={styles.projectDetails}>
                  <span>Konum: Merkez Bölge</span>
                  <span>Başlangıç: 01.03.2024</span>
                  <span>İlerleme: %65</span>
                </div>
                <div className={styles.projectActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Güncelle</button>
                </div>
              </div>
              
              <div className={styles.projectCard}>
                <div className={styles.projectHeader}>
                  <h3>Kıyı Bandı Düzenleme</h3>
                  <span className={styles.statusBadge}>Planlandı</span>
                </div>
                <p className={styles.projectDescription}>
                  Kıyı şeridinde yeşil alan oluşturma ve otomatik sulama kurulumu
                </p>
                <div className={styles.projectDetails}>
                  <span>Konum: Güney Bölge</span>
                  <span>Başlangıç: 15.05.2024</span>
                  <span>İlerleme: %0</span>
                </div>
                <div className={styles.projectActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Başlat</button>
                </div>
              </div>
              
              <div className={styles.projectCard}>
                <div className={styles.projectHeader}>
                  <h3>Okul Bahçeleri Projesi</h3>
                  <span className={styles.statusBadge}>Tamamlandı</span>
                </div>
                <p className={styles.projectDescription}>
                  5 okul bahçesinin peyzaj düzenlemesi ve sulama sistemleri
                </p>
                <div className={styles.projectDetails}>
                  <span>Konum: Çoklu Bölge</span>
                  <span>Tamamlanma: 28.03.2024</span>
                  <span>İlerleme: %100</span>
                </div>
                <div className={styles.projectActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Rapor</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'irrigation' && (
          <div className={styles.irrigationContainer}>
            <div className={styles.irrigationHeader}>
              <h2>Sulama Yönetimi</h2>
              <button className={styles.addButton}>+ Yeni Sulama Programı</button>
            </div>
            
            <div className={styles.irrigationGrid}>
              <div className={styles.irrigationCard}>
                <div className={styles.irrigationHeader}>
                  <h3>Merkez Park Sulama</h3>
                  <span className={styles.statusBadge}>Aktif</span>
                </div>
                <div className={styles.irrigationDetails}>
                  <p><strong>Program:</strong> Günlük - 06:00-08:00</p>
                  <p><strong>Alan:</strong> 2.5 ha</p>
                  <p><strong>Su Tüketimi:</strong> 45 m³/gün</p>
                  <p><strong>Son Çalışma:</strong> Bugün 06:00</p>
                </div>
                <div className={styles.irrigationActions}>
                  <button className={styles.actionButton}>Düzenle</button>
                  <button className={styles.actionButton}>Manuel Başlat</button>
                </div>
              </div>
              
              <div className={styles.irrigationCard}>
                <div className={styles.irrigationHeader}>
                  <h3>Kıyı Bandı Sulama</h3>
                  <span className={styles.statusBadge}>Aktif</span>
                </div>
                <div className={styles.irrigationDetails}>
                  <p><strong>Program:</strong> Haftalık - Çarşamba 05:00-07:00</p>
                  <p><strong>Alan:</strong> 1.8 ha</p>
                  <p><strong>Su Tüketimi:</strong> 28 m³/hafta</p>
                  <p><strong>Son Çalışma:</strong> 10.04.2024</p>
                </div>
                <div className={styles.irrigationActions}>
                  <button className={styles.actionButton}>Düzenle</button>
                  <button className={styles.actionButton}>Manuel Başlat</button>
                </div>
              </div>
              
              <div className={styles.irrigationCard}>
                <div className={styles.irrigationHeader}>
                  <h3>Spor Alanları Sulama</h3>
                  <span className={styles.statusBadge}>Beklemede</span>
                </div>
                <div className={styles.irrigationDetails}>
                  <p><strong>Program:</strong> Günlük - 20:00-22:00</p>
                  <p><strong>Alan:</strong> 3.2 ha</p>
                  <p><strong>Su Tüketimi:</strong> 62 m³/gün</p>
                  <p><strong>Son Çalışma:</strong> Dün 20:00</p>
                </div>
                <div className={styles.irrigationActions}>
                  <button className={styles.actionButton}>Düzenle</button>
                  <button className={styles.actionButton}>Aktif Et</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'reports' && (
          <div className={styles.reportsContainer}>
            <div className={styles.reportsHeader}>
              <h2>Peyzaj Raporları</h2>
              <button className={styles.addButton}>+ Yeni Rapor Oluştur</button>
            </div>
            
            <div className={styles.reportsList}>
              <div className={styles.reportItem}>
                <div className={styles.reportInfo}>
                  <h3>Aylık Peyzaj Raporu - Mart 2024</h3>
                  <p>Oluşturulma: 01.04.2024 | Kapsam: Tüm projeler</p>
                </div>
                <div className={styles.reportActions}>
                  <button className={styles.viewButton}>Görüntüle</button>
                  <button className={styles.downloadButton}>İndir</button>
                </div>
              </div>
              
              <div className={styles.reportItem}>
                <div className={styles.reportInfo}>
                  <h3>Sulama Analizi Raporu</h3>
                  <p>Oluşturulma: 05.04.2024 | Kapsam: Sulama sistemleri</p>
                </div>
                <div className={styles.reportActions}>
                  <button className={styles.viewButton}>Görüntüle</button>
                  <button className={styles.downloadButton}>İndir</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MunicipalityLandscapeDashboard;

